import React, { createRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { Yams, YamsController } from '@fttb/common';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { getTopPosition } from "../../../utils";
import { getCurrentCityBounds, getCurrentCityGeo, getMapApikey } from "../../../../store/blocks/checkAddress/selectors";
import { setChangePositionTop, setMarkerAddress } from "../../../../store/checkAddress/actions";
import { getPositionNavButtons } from "../../../../store/checkAddress/selectors";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var controller = new YamsController();
var _AddressMap = function _AddressMap(_ref) {
  var apikey = _ref.apikey,
    bounds = _ref.bounds,
    center = _ref.center,
    children = _ref.children,
    className = _ref.className,
    onClick = _ref.onClick,
    positionNavButtons = _ref.positionNavButtons,
    setPositionTop = _ref.setPositionTop;
  var refWrapMap = /*#__PURE__*/createRef();
  useEffect(function () {
    var position = getTopPosition(refWrapMap.current);
    setPositionTop(position);
  }, [refWrapMap]);
  return /*#__PURE__*/React.createElement(Yams, {
    apikey: apikey,
    className: cn('component', className),
    controller: controller,
    defaultState: {
      bounds: bounds,
      center: center
    },
    modules: ['geocode'],
    onClick: onClick,
    positionTop: positionNavButtons,
    refWrapMap: refWrapMap,
    "data-t-id": "components-AddressMap"
  }, children);
};
_AddressMap.propTypes = process.env.NODE_ENV !== "production" ? {
  apikey: PropTypes.string,
  bounds: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  center: PropTypes.arrayOf(PropTypes.number),
  children: PropTypes.node,
  className: PropTypes.string,
  positionNavButtons: PropTypes.number
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    apikey: getMapApikey(state),
    bounds: getCurrentCityBounds(state),
    center: getCurrentCityGeo(state),
    positionNavButtons: getPositionNavButtons(state)
  };
};
var mapDispatchToProps = {
  onClick: setMarkerAddress,
  setPositionTop: setChangePositionTop
};
export var AddressMap = connect(mapStateToProps, mapDispatchToProps)(_AddressMap);